// EAA-755: the stylesheet imports come FIRST, above `@/App`.
//
// ES imports evaluate in source order, so with `@/App` above them the whole
// page graph — including every co-located `*.module.css` wrapped in
// `@layer page { ... }` — was injected before global.css declared the layer
// order. CSS pins a layer at its first appearance, so `page` was registered
// first (lowest priority) and `chrome` outranked it, inverting the cascade for
// every module in the app.
//
// index.html now declares the order in a <head> <style>, which is what
// actually guarantees it; this ordering is the second line of defence, so a
// future import-sorter cannot quietly recreate the inversion in the bundle.
import '@/styles/fonts.css';
import '@/styles/tokens.css';
import '@/styles/global.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { App } from '@/App';
import { UiKitProvider } from '@/components/UiKitProvider';
import { ConfigProvider } from '@/config/ConfigProvider';
import { ThemeProvider } from '@/theme/ThemeProvider';
import { queryClient } from '@/queryClient';
// EAA-1845: side-effect import runs i18next's init() before anything renders.
import '@/i18n';

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <ConfigProvider>
            <QueryClientProvider client={queryClient}>
                {/* EAA-1844: mounts the light/dark theme state above
                    UiKitProvider so the shared kit's colour seam (wired in a
                    parallel change) can read the resolved theme too. */}
                <ThemeProvider>
                    {/* EAA-1804: mounts the shared kit's theme/colour/text seams for
                        the whole tree — see UiKitProvider for what it wires. */}
                    <UiKitProvider>
                        <App />
                    </UiKitProvider>
                </ThemeProvider>
            </QueryClientProvider>
        </ConfigProvider>
    </StrictMode>
);
